export default "__VITE_ASSET__BRoNG6eX__"